import { useSelector } from "react-redux"
import { paramsPostTipoCambio } from "../../bussines/params/addEditTipoCambio.params";
import { EditTipoCambioDatasource } from "../../data/datasources/EditTipoCambio.datasource";
import { toast } from 'lib.front';

const useEditTipoCambio = () => {
    const usuario = useSelector((state:any) => state.auth.usuario);
    const apiKey = usuario?.key;
    const enabled = !!apiKey;
    const postEditTipoCambio = async (params: paramsPostTipoCambio) => {
        try {
            const datasource = new EditTipoCambioDatasource(apiKey);
            const response = await datasource.postEditTipoCambio(params);
            return response;
        } catch (err) {
            const message = err instanceof Error ? err.message : String(err);
            toast.showError(message);
            return null;
        }
    };

    return {postEditTipoCambio: postEditTipoCambio, enabled };
};

export default useEditTipoCambio;